/**
 * Origem da venda pelo `sale_zone_area_object_id` que o PDV grava:
 * acima de 999999 é Delivery; até ele (ou sem zona) é Mesa/Balcão.
 * A API usa a mesma regra (DashboardController::DELIVERY_ZONE_MIN).
 */
export const DELIVERY_ZONE_MIN = 999999;

export const isDeliveryZone = (zoneId: unknown) => Number(zoneId) > DELIVERY_ZONE_MIN;
